// src/api/reservations.js
import axios from "axios";
import {DOMEN_BASE} from "../assets/config/constants";

const handleError = (err) => {
    // можно заменить на централизованную обработку ошибок
    console.error(err);
    throw err;
};

export const apiGetList = (year, month, room_id) =>
    axios
        .get(`${DOMEN_BASE}/data/edit/getListReserv.php`, {
            params: {year, month, room_id},
        })
        .catch(handleError);

export const apiGetByClient = (client_name) =>
    axios
        .get(`${DOMEN_BASE}/data/edit/getListReservClientName.php`, {
            params: {client_name},
        })
        .catch(handleError);


export const apiAdd = async (r) => {
    try {
        const {data} = await axios.post(`${DOMEN_BASE}/data/edit/saveListReserv.php`, {
            rooms_id: r.rooms_id,
            manager_id: r.manager_id,
            Date_In: r.Date_In,
            Date_Out: r.Date_Out,
            Client_Name: r.Client_Name,
            phone: r.phone
        });
        // console.log('data : ', data);
        return data;
    } catch (err) {
        console.error("Ошибка загрузки данных:", err);
    }
}

export const apiUpdate = async (r) => {
    try {
        const {data} = await axios.put(`${DOMEN_BASE}/data/edit/saveListReserv.php`, {
            id: r.id,
            rooms_id: r.rooms_id,
            manager_id: r.manager_id,
            Date_In: r.Date_In,
            Date_Out: r.Date_Out,
            Client_Name: r.Client_Name,
            phone: r.phone
        });
        // console.log('data : ', data);
        return data;

    } catch (err) {
        console.error("Ошибка загрузки данных:", err);
    }

}

export const apiDelete = (id) =>
    axios
        .delete(`${DOMEN_BASE}/data/edit/delListReserv.php`, {
            data: {id},
        })
        .catch(handleError);

export const apiSafeAction = (r) =>
    axios
        .post(`${DOMEN_BASE}/data/edit/safeAction/safe_action.php`, {
            id: r.id,
            dn_text: r.Date_In,
            dk_text: r.Date_Out,
            rooms_id: r.rooms_id,
        })
        .catch(handleError);
